import { useParams } from "react-router";

import { SEOHead } from "@/components/helpers/seo/SEOHead";
import { Box } from "@/components/layout/flexbox";
import { Nav } from "@/components/nav/Nav";
import { Authenticate } from "@/components/pages_logged_in/Authenticate";
import { RoleplayContent } from "@/components/pages_logged_in/roleplays/details/RoleplayContent";
import { NotFound } from "@/components/pages_public/404/NotFound";
import { SIDE_NAV_WIDTH } from "@/css/constants";
import { useRoleplayQuery } from "@/graphql";

function RoleplayDetailContent() {
  const { slug } = useParams();

  const { loading, error, data, refetch } = useRoleplayQuery({
    variables: {
      slug: slug,
    },
  });

  if (error) {
    return <Box>{error.message}</Box>;
  }

  const roleplay = data?.roleplay;
  const content = loading ? (
    <RoleplayContent
      loading={true}
      onCreateCollectionFinished={() => {
        refetch();
      }}
    />
  ) : !roleplay ? (
    <NotFound />
  ) : (
    <RoleplayContent
      roleplay={roleplay}
      onCreateCollectionFinished={() => {
        refetch();
      }}
    />
  );

  return (
    <>
      <SEOHead title={`${roleplay?.name || "Roleplay Details"} - Exec`} />
      <Nav />
      <Box ml={[0, 0, SIDE_NAV_WIDTH]}>{content}</Box>
    </>
  );
}

export function RoleplayDetailPage() {
  return (
    <Authenticate maxWidth="100%" layout="full">
      <RoleplayDetailContent />
    </Authenticate>
  );
}
